// extracted by mini-css-extract-plugin
module.exports = {"label":"_37UOFI mz-default-dark-font","extendedView":"_1HrqDA","bags":"_2m7CLz","tooltip":"_3PF021","mobile":"_1y-4Xd"};